export default __webpack_public_path__ + "static/media/class.874916c1.jpg";